import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Modal from 'components/common/Modal';
import ModalPartnership from 'components/Popup/ModalPartnership';

var PartnershipService = function PartnershipService() {
  var _Modal = Modal(),
      openModal = _Modal.openModal,
      closeModal = _Modal.closeModal,
      ModalPortal = _Modal.ModalPortal;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "sub-wrap type2",
      children: [/*#__PURE__*/_jsxs("h2", {
        children: ["\uB85C\uCEEC\uC2A4\uD2F0\uCE58\uC640 \uD568\uAED8 \uD560 ", /*#__PURE__*/_jsx("br", {}), "\uB2E4\uC591\uD55C \uD30C\uD2B8\uB108\uB97C ", /*#__PURE__*/_jsx("br", {}), "\uAE30\uB2E4\uB9BD\uB2C8\uB2E4"]
      }), /*#__PURE__*/_jsxs("p", {
        children: ["\uC790\uAE30\uB9CC\uC758 \uC804\uBB38\uC131\uACFC \uCF58\uD150\uCE20\uB97C \uBC14\uD0D5\uC73C\uB85C \uAC00\uAC8C\uB97C \uC5F4\uACE0 \uC2F6\uC740 \uC608\uBE44\uCC3D\uC5C5\uC790", /*#__PURE__*/_jsx("br", {}), "\uB85C\uCEEC\uC2A4\uD2F0\uCE58 \uBA64\uBC84\uB4E4\uC5D0\uAC8C \uAC01\uC885 \uD504\uB85C\uBAA8\uC158\uC744 \uC81C\uACF5\uD558\uC5EC \uC81C\uD488 \uBC0F \uC11C\uBE44\uC2A4\uB97C \uD64D\uBCF4\uD558\uACE0 \uC2F6\uC740 \uC608\uBE44\uD30C\uD2B8\uB108", /*#__PURE__*/_jsx("br", {}), "\uAC01\uC885 \uC804\uC2DC \uBC0F \uCF58\uD150\uCE20 \uC81C\uC791 \uB4F1 \uB85C\uCEEC\uC2A4\uD2F0\uCE58\uC640 \uC7AC\uBBF8\uC788\uB294 \uCF5C\uB77C\uBCF4\uB808\uC774\uC158\uC744 \uD568\uAED8\uD558\uACE0 \uC2F6\uC740 \uC608\uBE44\uD30C\uD2B8\uB108"]
      }), /*#__PURE__*/_jsx("div", {
        className: "partnership",
        children: /*#__PURE__*/_jsx("div", {
          className: "in-btn",
          children: /*#__PURE__*/_jsx("a", {
            onClick: openModal,
            style: {
              cursor: 'pointer'
            },
            children: "\uD30C\uD2B8\uB108\uC2ED \uBB38\uC758\uD558\uAE30"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(ModalPortal, {
      children: /*#__PURE__*/_jsx(ModalPartnership, {
        closeModal: closeModal
      })
    })]
  });
};

export default PartnershipService;